const trimTrailingSlash = (value) => String(value || "").replace(/\/+$/, "");

const DEFAULT_CDN_BASE_URL = "https://cdn.lukkey.com";
const CDN_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_CDN_BASE_URL || DEFAULT_CDN_BASE_URL,
);

const isAbsoluteUrl = (value) => /^(?:[a-z]+:)?\/\//i.test(value);

export const withCdn = (assetPath) => {
  if (!assetPath || typeof assetPath !== "string") return assetPath;
  if (!CDN_BASE_URL) return assetPath;
  if (isAbsoluteUrl(assetPath)) return assetPath;
  if (!assetPath.startsWith("/")) return assetPath;

  // Only rewrite public media paths that are currently served from localhost.
  if (
    !assetPath.startsWith("/assets/") &&
    !assetPath.startsWith("/images/") &&
    !assetPath.startsWith("/lukkey-media/") &&
    !assetPath.startsWith("/supported-crypto/")
  ) {
    return assetPath;
  }

  return `${CDN_BASE_URL}${assetPath}`;
};
